import { IHandler, IMetaInfo, IPageTitleConstructor } from '../../interfaces';
import {
	TitleKeywordWhere,
	TitleKeywordWhatCountry,
	TitleKeywordWhat,
	TitleKeywordWhatWhere,
	TitleDiscipline,
	TitleDisciplineArea,
	TitleDisciplineAttendance,
	TitleDisciplineContinent,
	TitleDisciplineCountryDegreeType,
	TitleDisciplineCountry,
	TitleDisciplineDegreeType,
	TitleDisciplineDuration,
	TitleDisciplineFormat,
	TitleDisciplineTuitionFee,
	TitleDisciplineTuitionFeeAttendance,
	TitleDisciplineEducationalForm,
	TitleDisciplineEducationalFormCountry,
	TitleDisciplineMultipleAreas,
	TitleDisciplineMultipleCountries,
	TitleDisciplineMultipleContinents,
	TitleCountry,
	TitleCountryAttendanceDegreeType,
	TitleCountryDegreeType,
	TitleCountryDuration,
	TitleCountryFormat,
	TitleCountryTuitionFee,
	TitleCountryEducationalForm,
	TitleCountryMultiple,
	TitleCountryMultipleDegreeType,
	TitleCountryMultipleDuration,
	TitleCountryMultipleFormat,
	TitleCountryMultipleTuitionFee,
	TitleArea,
	TitleAreaMultiple,
	TitleAttendance,
	TitleAttendanceDegreeType,
	TitleContinent,
	TitleContinentMultiple,
	TitleOrganisation,
	TitleRoot,
	TitleAttendanceCountry,
	TitleSpecialProgrammesErasmusMundus,
	TitleSpecialProgrammesJointProgrammes,
	TitleCountryDegreeTypeOneYear,
	TitleTuitionFee,
	TitleTuitionFeeContinent
} from './';

export class PageTitleConstructor implements IPageTitleConstructor {
	private titleFirstHandler: IHandler<IMetaInfo> = new TitleKeywordWhere();

	public constructor() {
		this.titleFirstHandler
			// Keywords
			.setNext(new TitleKeywordWhatCountry())
			.setNext(new TitleKeywordWhat())
			.setNext(new TitleKeywordWhatWhere())
			// Organisation
			.setNext(new TitleOrganisation())
			// Attendance
			.setNext(new TitleAttendanceCountry())
			.setNext(new TitleAttendanceDegreeType())
			.setNext(new TitleAttendance())
			// Disciplines
			.setNext(new TitleDisciplineEducationalFormCountry())
			.setNext(new TitleDisciplineArea())
			.setNext(new TitleDisciplineAttendance())
			.setNext(new TitleDisciplineContinent())
			.setNext(new TitleDisciplineCountryDegreeType())
			.setNext(new TitleDisciplineCountry())
			.setNext(new TitleDisciplineDegreeType())
			.setNext(new TitleDisciplineDuration())
			.setNext(new TitleDisciplineFormat())
			.setNext(new TitleDisciplineEducationalForm())
			.setNext(new TitleDisciplineTuitionFeeAttendance())
			.setNext(new TitleDisciplineTuitionFee())
			.setNext(new TitleDisciplineMultipleCountries())
			.setNext(new TitleDisciplineMultipleAreas())
			.setNext(new TitleDisciplineMultipleContinents())
			.setNext(new TitleDiscipline())
			// Tuition fee
			.setNext(new TitleTuitionFee())
			.setNext(new TitleTuitionFeeContinent())
			// Locations
			.setNext(new TitleAreaMultiple())
			.setNext(new TitleCountryAttendanceDegreeType())
			.setNext(new TitleCountryDegreeType())
			.setNext(new TitleCountryDegreeTypeOneYear())
			.setNext(new TitleCountryDuration())
			.setNext(new TitleCountryFormat())
			.setNext(new TitleCountryTuitionFee())
			.setNext(new TitleCountryEducationalForm())
			.setNext(new TitleCountryMultipleDegreeType())
			.setNext(new TitleCountryMultipleDuration())
			.setNext(new TitleCountryMultipleFormat())
			.setNext(new TitleCountryMultipleTuitionFee())
			.setNext(new TitleCountryMultiple())
			.setNext(new TitleArea())
			.setNext(new TitleCountry())
			.setNext(new TitleContinent())
			.setNext(new TitleContinentMultiple())
			// Special programmes
			.setNext(new TitleSpecialProgrammesErasmusMundus())
			.setNext(new TitleSpecialProgrammesJointProgrammes())
			// Root
			.setNext(new TitleRoot());
	}

	public getPageTitle(): string {
		return this.titleFirstHandler.construct().pageTitle;
	}

	public getMetaTitle(): string {
		return this.titleFirstHandler.construct().metaTitle;
	}

	public getMetaDescription(): string {
		return this.titleFirstHandler.construct().metaDescription;
	}
}
